import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { SalonService } from '../service/salon.service';
import { SubdomainService } from '../service/subdomain.service';

export function subdomainRedirectInitializer(): () => Promise<void> {
  return async (): Promise<void> => {
    const document = inject(DOCUMENT);
    const router = inject(Router);
    const salonService = inject(SalonService);
    const subdomainService = inject(SubdomainService);

    const slug = subdomainService.getSubdomain();
    // console.log('# subdomainRedirectInitializer :: slug: ', slug);

    if (!slug) {
      return;
    }

    const salonId = await salonService.getSalonIdBySlug(slug);
    // console.log('# subdomainRedirectInitializer :: salonId: ', salonId);

    if (!salonId) {
      return;
    }

    // Preserve the deep-link path after the root, e.g. /cancel?bookingId=123
    // becomes /s/{salonId}/cancel?bookingId=123
    const deepPath = buildDeepPath(document, salonId);
    // console.log('# subdomainRedirectInitializer :: deepPath: ', deepPath);

    await router.navigateByUrl(deepPath, { skipLocationChange: true });
  };
}

function buildDeepPath(document: Document, salonId: string): string {
  const { pathname, search } = document.location;

  // Strip leading slash and any empty segments
  const trailingPath = pathname.replace(/^\/+/, '').replace(/\/+$/, '');
  // console.log('# buildDeepPath :: trailingPath: ', trailingPath);

  const salonBase = `/s/${salonId}`;
  // console.log('# buildDeepPath :: salonBase: ', salonBase);

  if (!trailingPath) {
    // console.log('# buildDeepPath :: !trailingPath, return: ', salonBase + search);
    return salonBase + search;
  }

  // console.log('# buildDeepPath :: return: ', `${salonBase}/${trailingPath}${search}`);
  return `${salonBase}/${trailingPath}${search}`;
}
